import Swiper from "swiper/bundle";

function initSwiper() {
  let screenWidth = window.innerWidth;
  if (screenWidth < 1024) {
    // Initialize Swiper with your desired options
    const swiper = new Swiper(".blog-swiper", {
      slidesPerView: 3,
      loop:true,
      speed:1000,
      autoplay:{
        clickable:true,
        disableOnInteraction:false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: ".blog-slide-next",
        prevEl: ".blog-slide-prev",
      },
    });
  }
}

initSwiper();

window.addEventListener("resize", initSwiper);
